<app-menu-buttons-page
  label="Cómo funciona"
  [topActions]="topActions"
  [backgroundImage]="backgroundImage"
  (actionClick)="onActionClick($event)"
>
</app-menu-buttons-page>
